<template>
    <div class="bill-card" style="min-width: 200px;">
        <div class="d-flex flex-row align-items-center">
            <div class="bill-card-image"><img :src="bill.provider.logo_path" alt=""></div>
            <div>{{ bill.name }}</div>
        </div>

        <div class="d-flex flex-row align-items-center mt-3">
            <div class="bill-card-details-list row row-cols-2" v-if="!hidePrices">

                <div class="card-detail">
                    <span>£{{ pricePerHousemate }}</span>
                    <h5>Per housemate</h5>
                </div>

                <div class="card-detail">
                    <span>£{{ (pricePerHousemate * housemates).toFixed(2)}}</span>
                    <h5>Monthly Total</h5>
                </div>
            </div>

            <div :class="{ 'ml-4': !hidePrices }">
                <button type="button" class="btn px-3 py-2" :class="[ selected ? 'btn-secondary' : 'btn-primary']"
                        @click='toggle(bill.id)' v-text="!selected ? 'Select plan' : 'Remove plan'"
                ></button>
            </div>
        </div>

    </div>
</template>

<script>
import BillCardMixin from "../../../mixins/BillCardMixin";
export default {

    name: "BillCardStandard",

    mixins: [ BillCardMixin ],

    computed: {
        pricePerHousemate() {
            return this.getPricePerHousemate()
        }
    }
}
</script>
